module.exports = require("core-js/library/fn/array/from");